// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5506":"1f090ebf","5756":"36821189","9446":"d6e7f5a7"}[chunkId] + ".chunk.css";
};